import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { ModalDismissReasons, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from '../../../_alert';
import { DatastoreService } from '../../../services/datastore.service';
import { ApiService } from '../../../services/jrni/api.service';
import { AvailabilityService } from '../../../services/jrni/availability.service';
import { BasketService } from '../../../services/jrni/basket.service';
import { DepartmentService } from '../../../services/jrni/department.service';
import { LoginService } from '../../../services/jrni/login.service';
import { MemberService } from '../../../services/jrni/member.service';
import { ServicesService } from '../../../services/jrni/services.service';

interface DialogData {
  action,
  user,
  header,
  continue
}

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss']
})
export class LoginPopupComponent implements OnInit {
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  submitted = false;
  message: string;
  path: string;
  patientRef: string;
  emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  errorMessage: string;

  // Define the login form
  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', Validators.required)
  });

  // Define the reset password form
  resetPasswordForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
  });

  selectedDepartment: any;
  forgotPassword: any;
  resetSubmitted: boolean;
  resetSuccess: boolean;
  hide: boolean = true;
  loginError: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<LoginPopupComponent>,
    private router: Router,
    private alertService: AlertService,
    private translateService: TranslateService,
    private loginService: LoginService,
    private memberService: MemberService,
    private basketService: BasketService,
    private availabilityService: AvailabilityService,
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private datastoreService: DatastoreService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dataStore: DatastoreService,
  ) {
    this.loginForm.controls["email"].setValue(this.data.user.email)
    this.loginForm.controls["email"].patchValue(this.data.user.email)
  }


  onNoClick(): void {
    this.dialogRef.close();
    
  }


  togglePasswordVisible() {
    this.hide = !this.hide;
  }

  // Getter for easy access to form fields
  get form() { return this.loginForm.controls; }

  // Getter for easy access to form fields
  get resetForm() { return this.resetPasswordForm.controls; }


  forgotPasswordToggle() {
    if (this.forgotPassword) {
      this.forgotPassword = false;
    } else {
      this.forgotPassword = true;
    }
  }

  async sendReset() {
    this.resetSubmitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    } else {
      let parentDepartment = await this.departmentService.getParentDepartment();

      this.apiService.passwordReset(this.resetPasswordForm.value.resetemail, parentDepartment.id).then((res) => {
        this.resetSuccess = true;
      })

    }
  }

  async onSubmit() {

    this.submitted = true;
    this.loginError = false
    // stop here if the login form is invalid
    if (this.loginForm.invalid) {
      return;
    } else {
      this.spinner.show()

      await this.basketService.deleteAllBaskets(this.selectedDepartment)
      this.loginService.loginMember(this.selectedDepartment, this.loginForm.value).then(async res => {
        await this.memberService.setMember(res);
        const service = await this.servicesService.get()
        if (service) {
          await this.remakeBasket()
        }
        this.continue()
      })
        .catch(async (error: HttpErrorResponse) => {
          await this.remakeBasket()
          if (error || error['response'] && error['response'].status === 401) {
            // this.scrollToTop()
            // this.alertService.error(this.translateService.instant('LOGIN.EMAIL_NOT_RECOGNISED'))
            this.loginError = true
          }
          this.spinner.hide()
        });


    }
  }

  async remakeBasket() {
    const basket = await this.basketService.createBasket(this.selectedDepartment)
    this.basketService.currentBasket = basket;
    const selectedSlot = await this.availabilityService.getSelectedSlot();
    const service = await this.servicesService.get()
    await this.basketService.addItem(
      this.datastoreService.selectedDepartment,
      service.id,
      service.durations[0],
      selectedSlot.datetime,
      []
    )
  }

  continue() {
    const selectedDepartment = this.datastoreService.selectedDepartment;
    console.log(selectedDepartment)
    if (selectedDepartment === null) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([`/departments`]).then(() => {
          this.dialogRef.close();
        })
      })
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([`/booking-details`]).then(() => {
          this.dialogRef.close();
        })
      })
    }
  }

  ngOnInit(): void {
    this.departmentService.get().then(selectedDepartment => {

      this.selectedDepartment = selectedDepartment;
      this.spinner.hide();
    }, err => {
      console.log(err);
      this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
      this.spinner.hide();
    });
  }

  sendToReset() {
    let staging = ""
    if (window.location.href.includes("staging") || window.location.href.includes("localhost")) {
      staging = "staging"
    }
    const url = `https://customer.jrni.com/?client=eastsussex&environment=hwrc${staging}`
    window.open(url, '_blank').focus();
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }

}



